var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('image-box-tool-with-options',_vm._b({ref:"menu",scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('color-picker-container',{attrs:{"current-color":_vm.currentColor},on:{"save":_vm.saveColor,"input":_vm.changeColor}})]},proxy:true}],null,false,3456956851)},'image-box-tool-with-options',Object.assign({}, {title: _vm.title,
    icon: _vm.icon,
    shadow: false},
    _vm.$attrs),false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }